import React from 'react';
import QRCode from 'qrcode.react';
import './index.scss';

const QRCodeGenerator = props => {
  const { qrCodeURLs } = props;

  return (
    <div className={'qr-codes'}>
      {!!qrCodeURLs?.length ? qrCodeURLs.map((url, i) =>
        <div
          key={i}
          className={'qr-code'}
        >
          <QRCode
            renderAs={'svg'}
            size={200}
            value={url}
          />
        </div>,
      ) : null}
    </div>
  );
};

export default QRCodeGenerator;